import axios from "../axios.js";

var api = {
  //获取卷子列表  (模考)
  getPraList(params) {
    return axios.post("index/mockexam/index", params);
  },
  //获取模考每一部分题目数量
  getParam(params) {
    return axios.post("index/mockexam/getParam", params);
  },
  //设置模考参数 (模考)
  setParam(params) {
    return axios.post("index/mockexam/setParam", params);
  },
  // 开始考试
  startMockExam(params) {
    return axios.post("index/mockexam/startMockexam", params);
  },
  // 答题
  submitAnswer(params) {
    return axios.post("index/mockexam/submitAnswer", params);
  },
  // 下一题
  next(params) {
    return axios.post("index/mockexam/next", params);
  },
  // 开始暂停
  suspend(params) {
    return axios.post("index/mockexam/suspend", params);
  },
  // 获取模考结果
  getMockResult(params) {
    return axios.post("index/mockexam/end", params);
  },
  // 获取考题解析
  getProblemAnalysis(params) {
    return axios.post("index/mockexam/topic", params);
  },
  // 继续考试
  countinueMock(params) {
    return axios.post("index/mockexam/continue", params);
  },
  // 休息
  rest(params) {
    return axios.post("index/mockexam/rest", params);
  },
  // 标记
  mark(params) {
    return axios.post("index/mockexam/mark", params);
  },
  // 标记列表
  review(params) {
    return axios.post("index/mockexam/review", params);
  },
  // 检查获取题目详情
  getMockexam(params) {
    return axios.post("index/mockexam/getMockexam", params);
  },
  // 检查答题返回
  returnReview(params) {
    return axios.post("index/mockexam/returnReview", params);
  },
  // 暂停开始检查
  suspendReview(params) {
    return axios.post("index/mockexam/suspendReview", params);
  },
  // 结束检查
  endReview(params) {
    return axios.post("index/mockexam/endReview", params);
  },


  //练习接口
  // 练习册信息,题目,题干,答案选项,题目耗时,平均正确率
  getExerciseBook(params) {
    return axios.post("index/Exercise/getExerciseBook", params);
  },
  // 开始练习
  startExercise(params) {
    return axios.post("index/Exercise/startExercise", params);
  },
  // 继续练习
  countinueExercise(params) {
    return axios.post("index/Exercise/continue", params);
  },
  // 提交练习答案
  submitExerciseAnswer(params) {
    return axios.post("index/Exercise/submitAnswer", params);
  },
  // 下一道练习题
  nextExercise(params) {
    return axios.post("index/Exercise/next", params);
  },
  // 练习结果
  exerciseResult(params) {
    return axios.post("index/Exercise/end", params);
  },
  // 练习小题答题结果
  topicResult(params) {
    return axios.post("index/Exercise/topic", params);
  },
  // 纠错
  errorCorrection(params) {
    return axios.post("index/user/errorCorrection", params);
  },
};

export default api;



// WEBPACK FOOTER //
// ./src/api/dryRun.js